<h2 mat-dialog-title>Upload a Treasure
</h2>
<mat-dialog-content class="mat-typography">
    <h5>Fields marked with an asterisk (*) are mandatory</h5>
    <p> Treasures are creative works you love, including your own or those you've discovered. Add your favorite
        creations, such as books, movies, tech, art, and music, to your Treasury. Start by sharing your first Treasure
        now.</p>

    <form class="form" [formGroup]="treasuryForm">

        <h3>Category <span class="required">*</span></h3>
        <div class="check-group">
            <div class="first-case">
                <div class="form-check">
                    <input class="form-check-input" type="radio" name="art" formControlName="art" id="exampleRadios2"
                        value="Art & Design">
                    <label class="form-check-label" for="exampleRadios2">
                        Art & Design
                    </label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" type="radio" name="art" id="exampleRadios3"
                        value="Books & Storytelling" formControlName="art">
                    <label class="form-check-label" for="exampleRadios3">
                        Books & Storytelling
                    </label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" type="radio" name="art" id="exampleRadios2" formControlName="art"
                        value="Dance">
                    <label class="form-check-label" for="exampleRadios2">
                        Dance
                    </label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" type="radio" name="art" formControlName="art" id="exampleRadios3"
                        value="Fashion">
                    <label class="form-check-label" for="exampleRadios3">
                        Fashion
                    </label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" type="radio" name="art" formControlName="art" id="exampleRadios3"
                        value="Film">
                    <label class="form-check-label" for="exampleRadios3">
                        Film
                    </label>
                </div>
            </div>
            <div>
                <div class="form-check">
                    <input class="form-check-input" type="radio" name="art" formControlName="art" id="exampleRadios1"
                        value="Music" checked>
                    <label class="form-check-label" for="exampleRadios1">
                        Music
                    </label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" type="radio" name="art" formControlName="art" id="exampleRadios2"
                        value="Tech & Science">
                    <label class="form-check-label" for="exampleRadios2">
                        Tech & Science
                    </label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" type="radio" name="art" formControlName="art" id="exampleRadios3"
                        value="Television">
                    <label class="form-check-label" for="exampleRadios3">
                        Television
                    </label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" type="radio" name="art" formControlName="art" id="exampleRadios2"
                        value="Virtual Reality">
                    <label class="form-check-label" for="exampleRadios2">
                        Virtual Reality
                    </label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" type="radio" name="art" formControlName="art" id="exampleRadios3"
                        value="Others">
                    <label class="form-check-label" for="exampleRadios3">
                        Others
                    </label>
                </div>
            </div>

        </div>

        <h3>Title <span class="required">*</span></h3>
        <input autocomplete="off" type="text" class="form-control" id="title" aria-describedby="emailHelp"
            placeholder=" Title for the Treasure up to 100 characters" formControlName="title" maxlength="100"
            [(ngModel)]="titleText">


        <h3>Picture <span class="required">*</span></h3>
        <!-- <p>From prototype through global deployment, Angular delivers the productivity and scalable
        infrastructure that supports Google's largest applications.</p> -->
        <div class="imgUpload" [ngClass]="imageBoxDisable ? 'imgUpload' : 'uncheckedClass'"
            (click)="image1.click();click()" accept="image/*">

            <div style="margin:2%">
                <image-cropper *ngIf="stopCropper" [imageChangedEvent]="imgChangeEvt" [maintainAspectRatio]="true"
                    [aspectRatio]="4 / 4" [resizeToWidth]="256" format="png"
                    (imageCropped)="imageCropped($event,'image')" (imageLoaded)="imgLoad()"
                    (cropperReady)="initCropper()" (loadImageFailed)="imgFailed()">
                </image-cropper>

                <figure class="icons" input type="file" accept="image/*">

                    <input class="form-control" id="fileupload" type="file" [disabled]="imageFlag" (change)="onFileChange($event)"
                        accept="image/*" style="display:none" #image1>
                    <div class="items-center" style="text-align:center;">
                        <img src="assets\svg\photo icon.svg" *ngIf="iconDisabled" height="50">
                    </div>
                    <figcaption class="vdocaption" style="color:black;text-align: center;" *ngIf="iconDisabled">
                       {{isEdit ? 'Change Treasury Picture' : 'Upload Treasury Picture'}}
                    </figcaption>
                    <img class="items-center" *ngIf="!stopCropper" [src]="croppedImage">


                </figure>
            </div>

        </div>
        <div style="display: flex;justify-content: center;">
            <button  class="btn btn-default"  (click)="cropImage('image1')" *ngIf="cropButton" type="submit" style="color:white;background-color: #F44336;">CROP</button>
        </div>
        <h3>Description <span class="required">*</span></h3>

        <textarea class="form-control" formControlName="description" maxlength="500" [(ngModel)]="descriptionText"
            placeholder="Provide a description for your Treasure of up to 500 characters"
            aria-label="With textarea"></textarea>

        <h3>Experience This Treasure <span class="required">*</span></h3>

        <p>Here you provide a link for others to learn more, access, or buy your Treasure from a trusted source
            (such as
            iTunes, Amazon, YouTube, Vimeo, Blog, Review, or the Creator’s website).

        </p>


        <input autocomplete="off" type="url" class="form-control" id="link" [(ngModel)]="linkText"
            formControlName="link" placeholder="Provide Link to learn more about this treasure">
        <span class="text-danger"
            *ngIf="(loginFormControl['link'].touched || submitted) && loginFormControl['link'].hasError('required')">
            URL is required
        </span>
        <span class="text-danger"
            *ngIf="((loginFormControl['link'].invalid || submitted) &&  loginFormControl['link'].errors.pattern)">
            Enter a valid URL
        </span>

    </form>

</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-dialog-close class="btn btn-default">Close</button>
    <button cdkFocusInitial class="btn btn-primary save-treasury-btn universal-button-gradient" (click)="onSubmit()"
        [disabled]="(loginFormControl['link'].invalid)"
        [ngStyle]="(descriptionText && titleText && croppedImage && linkText && (loginFormControl['link'].valid)) ?   {'cursor' :'pointer','opacity':'1'}:{'cursor': 'not-allowed','opacity':'0.65'}"
        type="submit">Save</button>
</mat-dialog-actions>


<ng-template #progressDialog>
    <mat-dialog-content>
        <p style="font-size: 18px;">Processing.. please wait!</p>
    </mat-dialog-content>
    <mat-spinner [diameter]="30" [strokeWidth]="3" mode="indeterminate" style="margin: auto;"></mat-spinner>
    <!-- <mat-dialog-actions align="end">
          <button mat-button matDialogClose color="primary">Dismiss</button>
        </mat-dialog-actions> -->
</ng-template>